import { FormElementType } from "~/enums/formElementType";
const stateOptions = [
  {label_title: "Maryland State Board of Podiatric Medical Examiners", value: "Podiatry"},
  {label_title: "Maryland State Board of Nursing, as a Nurse Practitioner or a Nurse Midwife", value:"Nursing"},
  {label_title: "Maryland State Board of Physicians", value: "Physician"},
  {label_title: "Maryland State Board of Dental Examiners", value:"Dental"},
];

const stateOptionsWithOther = [
  {label_title: "Maryland State Board of Podiatric Medical Examiners", value: "Podiatry"},
  {label_title: "Maryland State Board of Nursing, as a Nurse Practitioner or a Nurse Midwife", value:"Nursing"},
  {label_title: "Maryland State Board of Physicians", value: "Physician"},
  {label_title: "Maryland State Board of Dental Examiners", value: "Dental"},
  {label_title: "Maryland Board of Pharmacy", value: "Pharmancy"},
  {label_title: "Other", value: "Other"}
]

const yesNoOptions = [
  {label_title: "Yes", value: "Yes"},
  {label_title: "No", value: "No"}
]
export class MMCCProviderDropdownSchema {

  static _MMCCProviderOptions: any;

  static MMCCProviderOptions(mergeJson: object = {}) {
    let baseJson: object;
    if (!this._MMCCProviderOptions) {
      this._MMCCProviderOptions = stateOptions.map((e, ind) => {
        let json = e;
        json['sort_order'] = ind;
        baseJson = {
          formElementType: FormElementType.dropdownItem,
          json: json,
        };
        if (mergeJson) {
          return Object.assign(baseJson, mergeJson);
        } else {
          return baseJson;
        }
      });
    }
    return this._MMCCProviderOptions;
  }

  static _MMCCProviderOptionsWithOther: any;

  static MMCCProviderOptionsWithOther(mergeJson: object = {}) {
    let baseJson: object;
    if (!this._MMCCProviderOptionsWithOther) {
      this._MMCCProviderOptionsWithOther = stateOptionsWithOther.map((e, ind) => {
        let json = e;
        json['sort_order'] = ind;
        baseJson = {
          formElementType: FormElementType.dropdownItem,
          json: json,
        };
        if (mergeJson) {
          return Object.assign(baseJson, mergeJson);
        } else {
          return baseJson;
        }
      });
    }
    return this._MMCCProviderOptionsWithOther;
  }

  static _YesNoOptions: any;

  static YesNoOptions(mergeJson: object = {}) {
    let baseJson: object;
    if (!this._YesNoOptions) {
      this._YesNoOptions = yesNoOptions.map((e, ind) => {
        let json = e;
        json['sort_order'] = ind;
        baseJson = {
          formElementType: FormElementType.radioButton,
          json: json,
        };
        if (mergeJson) {
          return Object.assign(baseJson, mergeJson);
        } else {
          return baseJson;
        }
      });
    }
    return this._YesNoOptions;
  }
}

export const MMCCProviderItems = MMCCProviderDropdownSchema.MMCCProviderOptions();
export const MMCCProviderItemsWithOther = MMCCProviderDropdownSchema.MMCCProviderOptionsWithOther();
export const MMCCYesNoItems = MMCCProviderDropdownSchema.YesNoOptions();